import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "@/data/products";
import { waProduct } from "@/lib/whatsapp";

export const ProductShowcase = ({ limit }) => {
    const items = limit ? PRODUCTS.slice(0, limit) : PRODUCTS;

    return (
        <section id="products" className="relative py-24 md:py-32 bg-ink text-bone" data-testid="product-showcase">
            <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="flex items-end justify-between gap-6 mb-14 md:mb-20 flex-wrap">
                    <div>
                        <div className="font-mono text-[10px] uppercase tracking-widest text-bone/50">
                            Chapter · 05 / The Range
                        </div>
                        <h2 className="mt-4 font-display text-5xl md:text-7xl leading-[0.95] tracking-[-0.02em]">
                            Fifteen coatings.
                            <br />
                            <span className="italic text-brand-yellow">One climate.</span>
                        </h2>
                    </div>
                    <a
                        href="/products"
                        className="btn-pill border border-bone/25 hover:bg-bone hover:text-ink"
                        data-testid="view-all-products"
                    >
                        View all products <ArrowUpRight size={16} />
                    </a>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-bone/10 border border-bone/10">
                    {items.map((p, i) => (
                        <motion.a
                            key={p.id}
                            href={waProduct(p.name)}
                            target="_blank"
                            rel="noreferrer"
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.7, delay: (i % 3) * 0.08 }}
                            className="group relative bg-ink p-8 md:p-10 flex flex-col justify-between min-h-[280px] hover:bg-[#151517] transition-colors"
                            data-testid={`product-card-${p.id}`}
                        >
                            <div className="flex items-start justify-between">
                                <span
                                    className="w-3 h-3 rounded-full"
                                    style={{ background: p.accent }}
                                />
                                <span className="font-mono text-[10px] tracking-widest text-bone/40">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                            </div>
                            <div>
                                <div className="text-xs font-mono uppercase tracking-widest text-bone/40 mb-3">
                                    {p.category}
                                </div>
                                <h3 className="font-display text-3xl md:text-4xl leading-tight mb-3">
                                    {p.name}
                                </h3>
                                <p className="text-bone/60 text-sm leading-relaxed max-w-sm">
                                    {p.blurb}
                                </p>
                                <div className="mt-6 flex items-center gap-2 text-sm text-brand-yellow opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                                    Enquire on WhatsApp <ArrowUpRight size={14} />
                                </div>
                            </div>
                        </motion.a>
                    ))}
                </div>
            </div>
        </section>
    );
};
